import { render } from "./StreamPlayerLocal.vue?vue&type=template&id=3782830e&scoped=true"
import script from "./StreamPlayerLocal.vue?vue&type=script&lang=js"
export * from "./StreamPlayerLocal.vue?vue&type=script&lang=js"

import "./StreamPlayerLocal.vue?vue&type=style&index=0&id=3782830e&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3782830e"]])

export default __exports__